import { render, staticRenderFns } from "./UnifiedDash.vue?vue&type=template&id=49aefb60&scoped=true&"
import script from "./UnifiedDash.vue?vue&type=script&lang=js&"
export * from "./UnifiedDash.vue?vue&type=script&lang=js&"
import style0 from "./UnifiedDash.vue?vue&type=style&index=0&id=49aefb60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aefb60",
  null
  
)

export default component.exports